import * as d3 from 'd3';
import React, { Component } from 'react';
// import randomcolor from 'randomcolor';
import { Dimmer, Loader } from 'semantic-ui-react';

const angularCoefficient = (minX, maxX, minY, maxY) => {
  // y = mx+b
  // https://en.wikipedia.org/wiki/Slope
  const m = (maxY - minY) / (maxX - minX);
  return value => {
    const x = value - minX;
    const b = minX;
    const output = m * x + b;

    return output;
  };
};

class Circumplex extends Component {
  static removeChildren(container) {
    while (container.firstChild) {
      container.firstChild.remove();
    }
  }

  static createRange(from, to, rangeX, rangeY) {
    return d3
      .scaleLinear()
      .domain([from, to])
      .range([rangeX, rangeY]);
  }

  static renderLegendElement(title, element) {
    return (
      <div className="circumplex__legend">
        <div className="circumplex__legend-title">
          <h5 className="circumplex__table-title">{title}</h5>
        </div>
        <div className="circumplex__table">{element}</div>
      </div>
    );
  }

  static drawGrid(container, x, y, domainwidth, domainheight) {
    const xAxis = d3.axisBottom(x).ticks(10);
    const yAxis = d3.axisLeft(y).ticks(10);

    container
      .append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0,${y.range()[0]})`)
      .call(xAxis);
    container
      .append('g')
      .attr('class', 'x grid')
      .call(xAxis.tickSize(domainheight).tickFormat(''));
    container
      .append('line')
      .attr('class', 'x center')
      .attr('x1', domainwidth / 2)
      .attr('y1', domainheight)
      .attr('x2', domainwidth / 2)
      .attr('y2', 0)
      .style('stroke-width', 2)
      .style('stroke', 'black')
      .style('fill', 'none');

    container
      .append('g')
      .attr('class', 'y axis')
      .call(yAxis);
    container
      .append('g')
      .attr('class', 'y grid')
      .attr('transform', `translate(${domainwidth}, 0)`)
      .call(yAxis.tickSize(domainwidth).tickFormat(''));
    container
      .append('line')
      .attr('class', 'x center')
      .attr('x1', 0)
      .attr('y1', domainheight / 2)
      .attr('x2', domainwidth)
      .attr('y2', domainheight / 2)
      .style('stroke-width', 2)
      .style('stroke', 'black')
      .style('fill', 'none');
  }

  static drawPoints(data, container, x, y) {
    container
      .selectAll('circle')
      .data(data)
      .enter()
      .append('circle')
      .attr('class', 'dot')
      // .attr("r", 7)
      .attr('r', (d, i) => d.radius)
      .attr('cx', d => {
        return x(d.x);
      })
      .attr('cy', d => {
        return y(d.y);
      })
      .attr('fill', (d, i) => d.color)
      .attr('stroke', (d, i) => d.color)
      .attr('stroke-width', 2.5);
  }

  constructor(props) {
    super(props);

    this.state = {
      isRendering: false
    };
    this.container = React.createRef();
  }

  componentDidMount() {
    this.drawChart();
  }

  componentDidUpdate() {
    this.drawChart();
  }

  getData() {
    return this.props.circumplex;
  }

  drawChart() {
    const container = this.container.current;

    if (!container) return;

    Circumplex.removeChildren(container);

    const svg = d3.select('#scatter');
    const margin = { top: 30, right: 30, bottom: 40, left: 50 };
    const width = +svg.attr('width');
    const height = +svg.attr('height');
    const domainwidth = width - margin.left - margin.right;
    const domainheight = height - margin.top - margin.bottom;

    const data = this.getData();

    const x = Circumplex.createRange(-1, 1, 0, domainwidth);
    const y = Circumplex.createRange(-1, 1, domainheight, 0);
    // const x = this.createRange(-0.5, 0.5, 0, domainwidth);
    // const y = this.createRange(-0.5, 0.5, domainheight, 0);

    const topContainer = svg
      .append('g')
      .attr('height', height)
      .attr('width', width);

    topContainer
      .append('text')
      .attr('transform', `translate(${width / 2}, ${height})`)
      .style('text-anchor', 'middle')
      .text('Emotion');

    topContainer
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', 0)
      .attr('x', 0 - height / 2)
      .attr('dy', '1em')
      .style('text-anchor', 'middle')
      .text('Arousal');

    const gridContainer = svg
      .append('g')
      .attr('height', domainheight)
      .attr('width', domainwidth)
      .attr('transform', `translate(${margin.left}, ${margin.top})`);

    Circumplex.drawGrid(gridContainer, x, y, domainwidth, domainheight);

    Circumplex.drawPoints(data.data, gridContainer, x, y);
  }

  render() {
    const congnitiveSize = [];
    const eventsColors = [];

    if (this.props.circumplex && this.props.circumplex.canItBeRender) {
      const sizeAngularCoefficient = angularCoefficient(
        this.props.circumplex.minSize,
        this.props.circumplex.maxSize,
        this.props.circumplex.minSizeRadius,
        this.props.circumplex.maxSizeRadius
      );

      for (
        let size = this.props.circumplex.minSize;
        size < this.props.circumplex.maxSize;
        size += this.props.circumplex.sizeStep
      ) {
        const radius = sizeAngularCoefficient(size);

        congnitiveSize.push(
          <div className="journeyMap__table-values journeyMap__table-cognitive" key={size}>
            <span className="journeyMap__table-cognitive-circle">
              <svg width="35" height="35">
                <circle
                  stroke="#B5B5B5"
                  strokeWidth="2"
                  fill="#D8D8D8"
                  cx="17.5"
                  cy="17.5"
                  r={radius}
                />
              </svg>
            </span>
            <span className="journeyMap__table-cognitive-values">{size.toFixed(2)}</span>
          </div>
        );
      }
    }

    if (this.props.circumplex && this.props.circumplex.canItBeRender) {
      for (let i = 0; i < this.props.circumplex.data.length; i++) {
        const dataPoint = this.props.circumplex.data[i];

        const { color } = dataPoint;
        eventsColors.push(
          <div className="journeyMap__table-values journeyMap__table-cognitive" key={color}>
            <span className="journeyMap__table-cognitive-circle">
              <svg width="35" height="35">
                <circle stroke={color} strokeWidth="2" fill={color} cx="17.5" cy="17.5" r="10" />
              </svg>
            </span>
            <span className="journeyMap__table-cognitive-values">{dataPoint.eventName}</span>
          </div>
        );
      }
    }

    let elementToShow = [];
    if (this.props.circumplex && this.props.circumplex.canItBeRender)
      elementToShow = [
        <div key="whatever2">
          {Circumplex.renderLegendElement('Cognitive load:', congnitiveSize)}
          {Circumplex.renderLegendElement('Events', eventsColors)}

          {/* <div className="circumplex__table"> */}
          {/*   <h5 className="circumplex__table-title"> */}
          {/*     Cognitive load: */}
          {/*   </h5> */}
          {/*   {congnitiveSize} */}
          {/* </div> */}

          {/* <div style={{display:"flex"}}> */}

          {/*   <div style={{margin: '7px 0px'}}> */}
          {/*     <h5 className="circumplex__table-title"> */}
          {/*       Events */}
          {/*     </h5> */}
          {/*   </div> */}
          {/*   <div className="circumplex__table"> */}
          {/*     {eventsColors} */}
          {/*   </div> */}
          {/* </div> */}

          {/* <div className="journeyMap__table journeyMap__table--valence"> */}
          {/*   <h5 className="journeyMap__table-title journeyMap__table-title--valence"> */}
          {/*     Events: */}
          {/*   </h5> */}

          {/*   <div className="journeyMap__table-values journeyMap__table-gradient-min-max"> */}
          {/*       {eventsColors} */}
          {/*   </div> */}
          {/* </div> */}
        </div>
      ];

    return (
      <Dimmer.Dimmable>
        <Dimmer active={this.state.isRendering} inverted>
          <Loader size="huge">Generating circumplex</Loader>
        </Dimmer>

        {this.props.circumplex && this.props.circumplex.canItBeRender ? (
          <div>
            {elementToShow}

            <svg
              id="scatter"
              className={`journeyMap ${this.props.type}`}
              width="800"
              height="550"
              ref={this.container}
            />
          </div>
        ) : (
          <h5 style={{ textAlign: 'center' }}>No data</h5>
        )}

        {this.props.circumplex && this.props.circumplex.dataError ? (
          <p style={{ textAlign: 'center' }}>No data has been fetch or an error has occur</p>
        ) : (
          ''
        )}

        {this.props.circumplex && this.props.circumplex.keyNameError ? (
          <p style={{ textAlign: 'center' }}>A key name in the data is missing</p>
        ) : (
          ''
        )}
      </Dimmer.Dimmable>
    );
  }
}

export default Circumplex;

// export default connec(state => ({

// }))(Circumplex);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/visualisations/Circumplex.js